export enum DataUploadsRoutes {
  COLLEGE_LIST = 'College list',
  GRADEBOOK = 'Gradebook',
}

export const DataUploadsRoutesStates = {
  'College list': 'main.school.data-uploads.college-list',
  Gradebook: 'main.school.data-uploads.gradebook',
};
